import { Outlet } from '@tanstack/react-router';
import React, { ReactElement } from 'react';

import { ForecastSessionGate } from 'src/features/forecastSessions/ForecastSessionGate';
import { BrandSidebarWithHeader } from 'src/layouts/BrandSidebarWithHeader';

export function ConfigurationPage(): ReactElement {
  return (
    <BrandSidebarWithHeader fullWidth={true}>
      <ForecastSessionGate>
        <Outlet />
      </ForecastSessionGate>
    </BrandSidebarWithHeader>
  );
}
